import { FC, ReactNode, useState, useContext, useEffect } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { SidebarContext } from 'src/contexts/SidebarContext';

import PropTypes from 'prop-types';
import { Button, Badge, Collapse, ListItem } from '@mui/material';

import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { useSelector, useDispatch } from 'react-redux'
import { setSideBarActiveLink, selectSideBarActiveLink, setSideBarParentLink, selectParentLink } from '../../../../features/chat/layoutSlice'

interface SidebarMenuItemProps {
  children?: ReactNode;
  link?: string;
  icon?: any;
  badge?: string;
  open?: boolean;
  active?: boolean;
  name: string;
  menuItem: any;
}

const SidebarMenuItem: FC<SidebarMenuItemProps> = ({
  children,
  link,
  icon: Icon,
  badge,
  open: openParent,
  active,
  name,
  menuItem = null,
  ...rest
}) => {
  const [menuToggle, setMenuToggle] = useState<boolean>(openParent);

  const { toggleSidebar } = useContext(SidebarContext);
  const dispatch = useDispatch()
  const activeLink = useSelector(selectSideBarActiveLink);
  const selectedParentLink = useSelector(selectParentLink);
  const [isChild, setIsChild] = useState<boolean>(false);

  const toggleMenu = (menuName) => {
    let isChildMenu = false;

    if (selectedParentLink?.items) {
      for (let i = 0; i < selectedParentLink.items.length; i++) {
        if (selectedParentLink.items[i].name == menuName) {
          dispatch(setSideBarParentLink({ link: selectedParentLink }));
          setIsChild(true);
          isChildMenu = true;

        } else if (selectedParentLink.items[i]?.items?.length > 0) {
          let SubMenus = selectedParentLink.items[i];
          for (let j = 0; j < SubMenus.items.length; j++) {
            if (SubMenus.items[j].name == menuName) {
              dispatch(setSideBarParentLink({ link: selectedParentLink }));
              setIsChild(true);
              isChildMenu = true;

            }
          }
        }
      }
    }else if(selectedParentLink?.name == name && menuToggle){
      setMenuToggle(true);
    }else if(selectedParentLink?.name == name && !menuToggle){
      setMenuToggle(false);
    }




    // console.log('selectedParentLink', selectedParentLink);
    // console.log('activeLink', activeLink);
    // console.log('childmenu', isChildMenu);
    // console.log('menuName', menuName);
    if (isChildMenu == true) {
      setMenuToggle(true);
      // console.log('toggle true block')
    } else {

      // console.log('menuName toggle block')
      // setMenuToggle((Open) => !Open);
    }

    dispatch(setSideBarActiveLink({ activeLink: menuName }));
    if (!isChildMenu) {
      dispatch(setSideBarParentLink({ link: menuItem }));
    }

  };

  useEffect(() => {
    if (activeLink && (name != activeLink)) {
      setMenuToggle(false);
      // console.log('first block')
    }
    if (selectedParentLink?.name == name) {
       setMenuToggle((Open) => !Open);


      // console.log('last block_selectedParentLink?.name=' + selectedParentLink?.name + '_name_' + name + 'activeLink_' 
      // + activeLink+'menuToggle'+menuToggle)

    }

  }, [activeLink, selectedParentLink, isChild]);



  if (children) {
    return (
      <ListItem component="div" className="Mui-children" key={name} {...rest}>
        <Button
          className={clsx({ 'Mui-active': menuToggle, 'side-btn': true })}
          startIcon={Icon && <Icon />}
          endIcon={
            menuToggle ? <ExpandLessTwoToneIcon /> : <ExpandMoreTwoToneIcon />
          }
          onClick={() => { toggleMenu(name) }}
        >
          {name}
        </Button>
        <Collapse in={menuToggle}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem component="div" key={name} {...rest}>
      <Button
        activeClassName="Mui-active"
        component={RouterLink}
        onClick={() => { toggleSidebar(); toggleMenu(name) }}
        to={link}
        startIcon={Icon && <Icon />}
      >
        {name}
        {badge && <Badge badgeContent={badge} />}
      </Button>
    </ListItem>
  );
};

SidebarMenuItem.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  link: PropTypes.string,
  icon: PropTypes.elementType,
  badge: PropTypes.string,
  open: PropTypes.bool,
  name: PropTypes.string.isRequired
};

SidebarMenuItem.defaultProps = {
  open: false,
  active: false,
};

export default SidebarMenuItem;
